import React from "react";
import MultipleChoice from "./SessionQuestions/MultipleChoice";
import Matching from "./SessionQuestions/Matching";
import OpenQuestion from "./SessionQuestions/OpenQuestion";
import FillBlanks from "./SessionQuestions/FillBlanks";

const playAudio = (url) => {
  if (!url) return;
  try {
    new Audio(url).play();
  } catch (e) {
    console.error("Audio playback failed", e);
  }
};

const QuestionBody = ({ question, answer }) => {
  switch (question.type) {
    case "multiple-choice":
    case "multiple-answers":
      return (
        <MultipleChoice
          question={question}
          activeQuestionAnswer={answer}
          playAudio={playAudio}
        />
      );
    case "matching":
    case "drag-drop":
      return <Matching question={question} activeQuestionAnswer={answer} />;
    case "open":
      return <OpenQuestion question={question} activeQuestionAnswer={answer} />;
    case "fill-blanks":
      return <FillBlanks question={question} activeQuestionAnswer={answer} />;
    default:
      return (
        <div className="p-3 border rounded text-muted text-center">
          نوع السؤال غير مدعوم حالياً ({question.type})
        </div>
      );
  }
};

const ComprehensionReview = ({ questionSets, questionSetsResults }) => {
  if (!questionSets?.length) {
    return (
      <div className="text-center p-4 text-muted">
        لا يوجد أسئلة فهم وتحليل لهذه الجلسة
      </div>
    );
  }

  return (
    <div className="comprehension-review-root p-2">
      <div
        className="questions-scroll-container pe-2"
        style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden" }}
      >
        {questionSets.map((set, setIdx) => {
          const questions = set?.questions || [];

          return (
            <div key={set.id || setIdx} className="mb-4">
              {set.title && (
                <h5 className="fw-bold text-dark mb-4" dir="rtl">
                  {set.title}
                </h5>
              )}

              <div className="d-flex flex-column gap-4">
                {questions.map((question, qIdx) => {
                  const qId = question?.id ?? question?._id;
                  const setResults = questionSetsResults?.[setIdx];
                  const answer = setResults?.answers?.find(
                    (a) => String(a.questionId) === String(qId),
                  );

                  return (
                    <div
                      key={question.id || qIdx}
                      className="question-item-container"
                    >
                      <div
                        className="question-prompt-card p-3 rounded mb-3 d-flex align-items-center bg-white"
                        style={{ border: "1px solid #7bc6e8" }}
                        dir="rtl"
                      >
                        <h6
                          className="question-prompt-text mb-0 flex-grow-1"
                          style={{
                            color: "#4a4a4a",
                            textAlign: "right",
                            fontWeight: "500",
                          }}
                        >
                          {question.questionText}
                        </h6>
                        {question.questionAudio && (
                          <>
                            <div
                              className="mx-3"
                              style={{
                                width: "1px",
                                height: "24px",
                                backgroundColor: "#d0d0d0",
                              }}
                            ></div>
                            <button
                              className="btn btn-link p-0 d-flex align-items-center justify-content-center"
                              onClick={() => playAudio(question.questionAudio)}
                              style={{
                                cursor: "pointer",
                                width: "32px",
                                height: "32px",
                                color: "#000000",
                              }}
                              title="Play Audio"
                            >
                              <i className="ri-volume-up-line fs-5" />
                            </button>
                          </>
                        )}
                      </div>

                      <div className="question-body-container mt-2">
                        <QuestionBody question={question} answer={answer} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComprehensionReview;
